<div>
    <ul class="flex space-x-2 rtl:space-x-reverse">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Minha conta</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Perfil</span>
        </li>
    </ul>
    <div class="pt-5">
        <div class="mb-5 grid grid-cols-1 gap-5 lg:grid-cols-3 xl:grid-cols-4">
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Perfil</h5>
                </div>
                <div class="mb-5">
                    <div class="flex flex-col items-center justify-center">
                        <img src="/assets/images/user-profile.png" alt="" class="mb-5 h-24 w-24 rounded-full object-cover" />
                        <p class="text-xl font-semibold text-primary">{{user.profile.firstName}} {{user.profile.lastName}}</p>
                    </div>
                    <ul class="m-auto mt-5 flex max-w-[160px] flex-col space-y-4 font-semibold text-white-dark">
                        <!-- <li class="flex items-center gap-2">
                            <icon-coffee class="shrink-0" />
                            {{user.profile.}}
                        </li> -->
                        <li class="flex items-center gap-2">
                            <icon-calendar class="shrink-0" />
                            {{user.profile.dateOfBirth}}
                        </li>
                        <li class="flex items-center gap-2">
                            <icon-map-pin class="shrink-0" />
                            {{user.profile.address.city}}, {{user.profile.address.state}}
                        </li>
                        <li>
                            <a href="javascript:;" class="flex items-center gap-2">
                                <icon-mail class="h-5 w-5 shrink-0" />
                                <span class="truncate text-primary">{{user.profile.email}}</span></a
                            >
                        </li>
                        <li class="flex items-center gap-2">
                            <icon-phone />
                            <span class="whitespace-nowrap" dir="ltr">{{user.profile.contacts.mobilePhone}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="panel lg:col-span-2 xl:col-span-3">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Dados</h5>
                    <a class="btn btn-primary btn-custom cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto" (click)="editProfile()" title="Editar perfil">
                        <icon-pencil-paper />
                    </a>
                </div>
                <div class="mb-5">
                    <form [formGroup]="formUser" (submit)="onSubmit()">
                        <div formGroupName="profile">
                            <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                                <div>
                                    <label for="name">Nome</label>
                                    <input
                                        id="name"
                                        type="text"
                                        placeholder="Meu Nome"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="firstName"
                                    />
                                </div>
                                <div>
                                    <label for="profession">Sobrenome</label>
                                    <input
                                        id="profession"
                                        type="text"
                                        placeholder="Meu sobrenome"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="lastName"
                                    />
                                </div>
                                <div>
                                    <label for="name">Email</label>
                                    <input
                                        id="name"
                                        type="email"
                                        placeholder="exemplo@gmail.com"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="email"
                                    />
                                </div>
                                <div>
                                    <label for="profession">Idade</label>
                                    <input
                                        id="profession"
                                        type="date"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="dateOfBirth"
                                    />
                                </div>
                            </div>
                            <div class="my-7">
                                <h5 class="text-lg font-semibold dark:text-white-light">Endereço</h5>
                            </div>
                            <div formGroupName="address" class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                                <div>
                                    <label for="address">CEP</label>
                                    <input
                                        id="address"
                                        type="text"
                                        placeholder="00000-000"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="zip"
                                    />
                                </div>
                                <div>
                                    <label for="address">Rua</label>
                                    <input
                                        type="text"
                                        placeholder="Nome da rua com numero"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="street"
                                    />
                                </div>
                                <div>
                                    <label for="address">Complemento</label>
                                    <input
                                        type="text"
                                        placeholder="exemplo: apt 1"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="complement"
                                    />
                                </div>
                                <div>
                                    <label for="location">Cidade</label>
                                    <input
                                        type="text"
                                        placeholder="cidade"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="city"
                                    />
                                </div>
                                <div>
                                    <label for="location">Estado</label>
                                    <input
                                        type="text"
                                        placeholder="estado"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="state"
                                    />
                                </div>
                                <div>
                                    <label for="country">País</label>
                                    <select
                                        id="country"
                                        class="form-select form-select text-white-dark text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="country"
                                    >
                                        <option selected>Brazil</option>
                                        <option>Estados Unidos</option>
                                    </select>
                                </div>
                            </div>
                            <div class="my-7">
                                <h5 class="text-lg font-semibold dark:text-white-light">Contato</h5>
                            </div>
                            <div formGroupName="contacts" class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                                <div>
                                    <label for="phone">Telefone</label>
                                    <input
                                        id="phone"
                                        type="text"
                                        placeholder="(00) 00000-0000"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="phone"
                                    />
                                </div>
                                <div>
                                    <label for="email">Celular</label>
                                    <input
                                        id="email"
                                        type="text"
                                        placeholder="(00) 00000-0000"
                                        class="form-input text-white-dark disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]"
                                        formControlName="mobile"
                                    />
                                </div>
                                <div class="mt-3 sm:col-span-2">
                                    <button type="submit" class="btn btn-primary btn-custom">Enviar</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
